<script>
    import { onMount, afterUpdate } from 'svelte';
    import PDFObject from 'pdfobject';

    export let pdfUrl;
    let width = '100%';
    let height = '500px';

    let pdfContainer;

    var options = {
        title: "PDF",
        pdfOpenParams: { view: 'FitH', page: '1' },
        // forcePDFJS: true,
        PDFJS_URL: "/pdfjs/web/viewer.html"
    };

    onMount(() => {
        embedPDF();
    });

    $: embedPDF();

    function embedPDF() {
        if (pdfContainer) {
            pdfContainer.innerHTML = '';

            PDFObject.embed(pdfUrl, pdfContainer, options);
        }
    }

    afterUpdate(() => {
        embedPDF();
    });
</script>

<div bind:this={pdfContainer} class="flex max-h-full max-w-full h-full w-full">
    <!-- Contenu de secours si le PDF ne peut pas être chargé -->
    Votre navigateur ne peut pas afficher de PDF. <a href={pdfUrl}>Cliquez ici pour le télécharger.</a>
</div>
